module.exports = __webpack_public_path__ + "img/course_Image_two.bfbdd3d8.png";